/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Records_Region_LabelInputs */



/**
* | output |
* | --- |
* | "Auto Save Records" |
*
* @param {Automatic_Save_Records_Region_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_records_region_label = /** @type {((inputs?: Automatic_Save_Records_Region_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Records_Region_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrements de sauvegarde automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Speicherung von Datensätzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio automatico dei record")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое сохранение записей")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar registros automáticamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动保存记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードの自動保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड स्वतः सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Registros de salvamento automático")
	return /** @type {LocalizedString} */ ("Auto Save Records")
});